import { z } from 'zod/v3';
import { DataObjectOutputType } from '../types';

export const zDataObjectOutputType = z.nativeEnum(DataObjectOutputType);
